export * from './horizontal-facet.component';

